import { render } from "./TitleScheme.vue?vue&type=template&id=26dab00d&scoped=true&ts=true"
import script from "./TitleScheme.vue?vue&type=script&lang=ts"
export * from "./TitleScheme.vue?vue&type=script&lang=ts"

import "./TitleScheme.vue?vue&type=style&index=0&id=26dab00d&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26dab00d"]])

export default __exports__